// import { FinancePlan } from '../custom-types';

import { FuelType, TransactionStatusType, TransmissionType } from '@bus/models';

export interface DataStorageData {
  transaction: {
    id: string;
    status: TransactionStatusType;
    interactionManagementStatus: string;
  };
  customerData: any;
  custom: any;
  dealerData: {
    volkswagenGroupPartnerIds: string[];
    companyName: string;
    companyId: string;
    addresses: Array<{
      street: string;
      zipCode: string;
      city: string;
      houseNumber: string;
      state: string;
    }>;
    contactData: {
      emails: Array<{
        emailAddress: string;
      }>;
      mobilePhoneCountryCode: string;
      mobilePhoneNumber: string;
      telephoneCountryCode?: string;
      telephoneNumber?: string;
    };
  };
  financialProduct: {
    contracts: {
      legalEntityId: string;
    }[];
  };
  token: string;
}

export interface Dealer {
  name: string;
  street: string;
  zip: string;
  city: string;
  phone: string;
  id: string;
  email: string;
  houseNumber: string;
  regionId?: string;
}

export enum IMatchType {
  Best = 'Best',
  Great = 'Great',
  Good = 'Good',
  Fair = 'Fair',
  NoMatch = 'NoMatch'
}

export enum ICarSearchType {
  BYTYPE = 'ByType',
  BYMODEL = 'ByModel'
}

export interface MatchMakerAnswers {
  minPower?: number;
  maxPower?: number;
  condition?: string[]; // NEW or USED
  typeOfCar?: string[];
  modelOfCar?: string[];
  typeOfGears?: TransmissionType[];
  fuelTypes?: FuelType[];
  expectedMonthlyPayment?: number;
  expectedDuration?: number;
  milesPerYear?: number;
  isCompleted?: boolean;
  additionalDeposit?: number;
  noAdditionalDepositCheckbox?: boolean;
  carSearchType?: ICarSearchType;
  financePlan?: any;
  specialEquipments?: string[];
  additionalServices?: string[];
  additionalCustomerInformation?: string;
}

export interface CustomerContactDetails {
  firstName: string;
  lastName: string;
  phoneNumber: string;
  email: string;
  contactPreference: ContactOption;
}

export type LocalBrands = 'audi' | 'seat' | 'cupra' | 'vw' | 'vwn';

export enum ContactOption {
  PHONE = 'PHONE',
  EMAIL = 'EMAIL'
}

export type LocalLanguages = 'de-DE';
